import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.749,11.432a3.325,3.325,0,0,1-3.32,3.32H4.569a3.325,3.325,0,0,1-3.32-3.32V4.572a3.325,3.325,0,0,1,3.32-3.32h6.86a3.325,3.325,0,0,1,3.32,3.32.75.75,0,1,1-1.5,0,1.82,1.82,0,0,0-1.82-1.82H4.569a1.814,1.814,0,0,0-1.82,1.82v6.86a1.82,1.82,0,0,0,1.82,1.82h6.86a1.827,1.827,0,0,0,1.82-1.82.75.75,0,0,1,1.5,0Zm-1-3.43a.743.743,0,0,0-.75-.75H6.859L8.569,5.6a.753.753,0,1,0-1.05-1.08l-3.04,2.94a.739.739,0,0,0-.17.25.731.731,0,0,0,0,.58.852.852,0,0,0,.17.25l3.04,2.93a.775.775,0,0,0,.53.21.735.735,0,0,0,.54-.23.764.764,0,0,0-.02-1.06l-1.71-1.64H13A.749.749,0,0,0,13.749,8Z';
const draw24px =
  'M18.75,12a.75.75,0,0,1-.75.75H10.87l1.71,1.65a.75.75,0,0,1,0,1.06.78.78,0,0,1-.54.23.73.73,0,0,1-.52-.21l-3-2.94A.75.75,0,0,1,8.26,12a.72.72,0,0,1,.06-.29,1,1,0,0,1,.16-.24h0l3-2.93a.75.75,0,0,1,1.06,0,.75.75,0,0,1,0,1.06l-1.71,1.64H18A.76.76,0,0,1,18.75,12Zm1,4.05a.75.75,0,1,0-1.5,0A2.25,2.25,0,0,1,16,18.26H8A2.25,2.25,0,0,1,5.74,16V8A2.25,2.25,0,0,1,8,5.76h8A2.25,2.25,0,0,1,18.24,8a.75.75,0,1,0,1.5,0A3.75,3.75,0,0,0,16,4.26H8A3.75,3.75,0,0,0,4.24,8v8A3.75,3.75,0,0,0,8,19.76h8A3.75,3.75,0,0,0,19.74,16Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowGenericLeftIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowGenericLeft')) as IconWithRender;

ArrowGenericLeftIcon.displayName = 'ArrowGenericLeftIcon';
ArrowGenericLeftIcon.propTypes = Icon.propTypes;
ArrowGenericLeftIcon.renderIcon = (props) => (
  <ArrowGenericLeftIcon {...props} />
);
export default ArrowGenericLeftIcon;
